<template>
  <div v-loading="loading">
    <el-form :model="form" :rules="rules" ref="form" label-width="150px">
      <el-form-item label-width="0">
        <ul class="ul flex">
          <li class="li-active">1.企业信息</li>
          <li class="li-active-r"></li>
          <li class="li-l"></li>
          <li class="li">2.品牌与资质信息</li>
          <li class="li-r"></li>
          <li class="li-l"></li>
          <li class="li">3.供应商信息</li>
          <li class="li-r"></li>
        </ul>
      </el-form-item>
      <el-form-item label-width="0">
        <div class="title">
          <p></p>
          <p>纸质营业执照</p>
        </div>
      </el-form-item>
      <!-- <el-form-item label="供应商类型" prop="supType">
        <div class="flex">
          <div @click="form.supType = 0" :class="[form.supType === 0 ? 'supType-active' : 'supType']">
            <p>营客通自营</p>
            <p>客户认知高，流量大，平台活动支持，所有产品均需开具专用发票</p>
          </div>
          <div @click="form.supType = 1" :class="[form.supType === 1 ? 'supType-active' : 'supType', 'mgl20']">
            <p>营客通集市</p>
            <p>操作简单，费率低至1.8%，可不开具专用发票</p>
          </div>
        </div>
      </el-form-item> -->
      <el-form-item label="执照类型">多证合一营业执照（统一社会信用代码）</el-form-item>
      <el-form-item label="营业执照图片上传" prop="businessLicensePic">
        <div class="flex flex-end">
          <el-upload action="#" :auto-upload="false" :show-file-list="false" class="uploader"
            :on-change="value => handleChange(value, 'businessLicensePic')">
            <img v-if="form.businessLicensePic" :src="form.businessLicensePic">
            <i v-else class="el-icon-plus"></i>
          </el-upload>
          <el-button type="text" class="mgl10"
            @click="handlePreview('https://ksaximg.ksaxshop.com/register/%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7%E7%A4%BA%E5%9B%BE.png')">查看示例</el-button>
        </div>
        <p class="msg">图片尺寸请确保800px*800px以上，大小在10MB以内，支持png、jpg、jpeg、gif格式</p>
        <p class="msg">请上传清晰营业执照图片，系统识别公司信息自动进行填写，营业执照复印件需加盖公司红章扫描上传</p>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="form.companyName"></el-input>
            <p class="msg">请按照营业执照登记的完整名称填写，如有（）请在输入法为中文下输入</p>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码" prop="creditCode">
            <el-input v-model="form.creditCode"></el-input>
            <p class="msg">请按照营业执照上的统一社会信用代码进行填写</p>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="营业执照所在地" prop="businessLicenseAddress1">
        <el-cascader v-model="form.businessLicenseAddress1" :options="businessLicenseAddress1List"
          :props="{ value: 'AreaName', label: 'AreaName', children: 'SubAreas' }"></el-cascader>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="住所" prop="businessLicenseAddress2">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 2 }" placeholder="请输入"
              v-model="form.businessLicenseAddress2">
            </el-input>
            <p class="msg">请按照营业执照上的住所填写</p>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="成立日期" prop="establishDate">
        <el-date-picker v-model="form.establishDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="营业期限" required>
        <div class="flex">
          <el-form-item prop="businessTermStart">
            <el-date-picker v-model="form.businessTermStart" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <p>&nbsp;&nbsp;至&nbsp;&nbsp;</p>
          <el-form-item prop="businessTermEnd">
            <el-date-picker v-model="form.businessTermEnd" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="注册资本" prop="registerCapital">
            <el-input v-model="form.registerCapital">
              <template slot="append">万元</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="经营范围" prop="businessRange">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请输入"
              v-model="form.businessRange">
            </el-input>
            <p class="msg">请与营业执照或企业信息公示网的经营范围保持一致</p>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-form-item label-width="0">
        <div class="title">
          <p></p>
          <p>法人信息</p>
        </div>
      </el-form-item>
      <el-form-item label="证件类型" prop="juridicalPersonCardType">
        <el-select v-model="form.juridicalPersonCardType" placeholder="请选择">
          <el-option label="大陆身份证" value="1"></el-option>
          <el-option label="护照" value="2"></el-option>
          <el-option label="港澳居民通行证" value="3"></el-option>
          <el-option label="台湾居民通行证" value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件图片上传" required>
        <div class="flex">
          <el-form-item prop="juridicalPersonCardPic1">
            <div class="flex flex-end">
              <el-upload action="#" :auto-upload="false" :show-file-list="false" class="uploader"
                :on-change="value => handleChange(value, 'juridicalPersonCardPic1')">
                <img v-if="form.juridicalPersonCardPic1" :src="form.juridicalPersonCardPic1">
                <i v-else class="el-icon-plus"></i>
              </el-upload>
              <el-button type="text" class="mgl10 mgr10"
                @click="handlePreview('https://ksaximg.ksaxshop.com/register/%E8%BA%AB%E4%BB%BD%E8%AF%81%E4%BA%BA%E5%83%8F%E5%9B%BE.png')">查看示例（正面）</el-button>
            </div>
          </el-form-item>
          <el-form-item prop="juridicalPersonCardPic2">
            <div class="flex flex-end">
              <el-upload action="#" :auto-upload="false" :show-file-list="false" class="uploader"
                :on-change="value => handleChange(value, 'juridicalPersonCardPic2')">
                <img v-if="form.juridicalPersonCardPic2" :src="form.juridicalPersonCardPic2">
                <i v-else class="el-icon-plus"></i>
              </el-upload>
              <el-button type="text" class="mgl10 mgr10"
                @click="handlePreview('https://ksaximg.ksaxshop.com/register/%E8%BA%AB%E4%BB%BD%E8%AF%81%E5%9B%BD%E5%BE%BD%E5%9B%BE.png')">查看示例（反面）</el-button>
            </div>
          </el-form-item>
        </div>
        <p class="msg">大小在10MB以内，支持png、jpg、jpeg、gif格式</p>
        <p class="msg">若为复印件，需加盖公司红章后上传</p>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="法人姓名" prop="juridicalPersonName">
            <el-input v-model="form.juridicalPersonName" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="法人证件号" prop="juridicalPersonCardNo">
            <el-input v-model="form.juridicalPersonCardNo" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="法人证件有效期" required>
        <div class="flex">
          <el-form-item prop="juridicalPersonStartDate">
            <el-date-picker v-model="form.juridicalPersonStartDate" type="date" placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <p>&nbsp;&nbsp;至&nbsp;&nbsp;</p>
          <el-form-item prop="juridicalPersonEndDate">
            <el-date-picker v-model="form.juridicalPersonEndDate" type="date" placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
            <el-checkbox v-model="form.juridicalPersonLongDate" class="mgl10">长期有效</el-checkbox>
          </el-form-item>
        </div>
      </el-form-item> -->
      <el-form-item label-width="0">
        <div class="title">
          <p></p>
          <p>税务信息</p>
        </div>
      </el-form-item>
      <el-form-item label="电子税务首页截图" prop="taxPic">
        <div class="flex flex-end">
          <el-upload action="#" :auto-upload="false" :show-file-list="false" class="uploader"
            :on-change="value => handleChange(value, 'taxPic')">
            <img v-if="form.taxPic" :src="form.taxPic">
            <i v-else class="el-icon-plus"></i>
          </el-upload>
          <div style="margin-left: 25px;">
            <div style="width:100px;position: relative;margin-bottom: 10px;cursor: pointer;"
              @click="handlePreview('https://ksaximg.ksaxshop.com/admin/20251203-143934.jpg')">
              <img src="https://ksaximg.ksaxshop.com/admin/20251203-143934.jpg" width="100">
              <p
                style="position: absolute;bottom:0;left:0;width:100%;height: 20px;line-height: 20px;background: rgba(0,0,0,0.5);color:#fff;font-size: 12px;text-align: center;">
                查看示例大图</p>
            </div>
            <p style="line-height: 1.2;margin-bottom: 12px;"><span
                style="line-height: 1.2;">国家税务局官网：</span><el-link type="primary"
                href="https://etax.shanghai.chinatax.gov.cn:8443/"
                target="_blank">https://etax.shanghai.chinatax.gov.cn:8443/</el-link></p>
          </div>
        </div>
        <p style="color:red;">请按示例图上传</p>
      </el-form-item>
      <div class="textC">
        <el-button type="primary" @click="handleNext">下一步</el-button>
      </div>
    </el-form>
    <el-dialog :visible.sync="previewVisible" width="70%">
      <img :src="previewUrl" alt="" class="w100">
    </el-dialog>
  </div>
</template>

<script>
import {
  KSAXApiRequest,
  getQiniuToken,
} from "../../api/api";
import { areaData } from './areaData'
export default {
  components: {},
  data() {
    return {
      loading: false,
      form: {},
      rules: {
        // supType: [{ required: true, message: '请选择供应商类型', trigger: 'change' }],
        businessLicensePic: [{ required: true, message: '请上传', trigger: 'change' }],
        taxPic: [{ required: true, message: '请上传', trigger: 'change' }],
        companyName: [{ required: true, message: '请填写', trigger: 'blur' }],
        creditCode: [{ required: true, message: '请填写', trigger: 'blur' }],
        businessLicenseAddress1: [{ required: true, message: '请选择', trigger: 'change' }],
        businessLicenseAddress2: [{ required: true, message: '请填写', trigger: 'blur' }],
        establishDate: [{ required: true, message: '请选择', trigger: 'change' }],
        businessTermStart: [{ required: true, message: '请选择', trigger: 'change' }],
        businessTermEnd: [{ required: true, message: '请选择', trigger: 'change' }],
        registerCapital: [{ required: true, message: '请填写', trigger: 'blur' }],
        businessRange: [{ required: true, message: '请填写', trigger: 'blur' }],
        juridicalPersonCardType: [{ required: true, message: '请选择', trigger: 'change' }],
        juridicalPersonCardPic1: [{ required: true, message: '请上传', trigger: 'change' }],
        juridicalPersonCardPic2: [{ required: true, message: '请上传', trigger: 'change' }],
        juridicalPersonName: [{ required: true, message: '请填写', trigger: 'blur' }],
        juridicalPersonCardNo: [{ required: true, message: '请填写', trigger: 'blur' }],
        juridicalPersonStartDate: [{ required: true, message: '请选择', trigger: 'change' }],
        juridicalPersonEndDate: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      qiniuToken: "",
      previewUrl: "",
      previewVisible: false,
      businessLicenseAddress1List: areaData
    };
  },
  created() {
    this.getQiniuToken()
    this.getDetail()
  },
  mounted() {

  },
  methods: {
    getDetail() {
      let data = {
        path: "Business_SupplierSettled/AddSupplierSettled",
        parms: "",
        parmsJson: {
          contactPhone: this.$route.query.phone,
          step: 0,
        }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          const { businessLicenseAddress, establishDate, businessTermStart, businessTermEnd, juridicalPersonCardPic } = res.data.response
          res.data.response.businessLicenseAddress1 = businessLicenseAddress ? businessLicenseAddress.split("-").slice(0, 3) : null
          res.data.response.businessLicenseAddress2 = businessLicenseAddress ? businessLicenseAddress.split("-").slice(-1).join("") : null
          res.data.response.establishDate = establishDate === "1900-01-01 00:00:00" ? null : establishDate
          res.data.response.businessTermStart = businessTermStart === "1900-01-01 00:00:00" ? null : businessTermStart
          res.data.response.businessTermEnd = businessTermEnd === "1900-01-01 00:00:00" ? null : businessTermEnd
          res.data.response.juridicalPersonCardPic1 = juridicalPersonCardPic ? juridicalPersonCardPic.split(",")[0] : null
          res.data.response.juridicalPersonCardPic2 = juridicalPersonCardPic ? juridicalPersonCardPic.split(",")[1] : null
          this.form = res.data.response
          this.form.supType = 0
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getQiniuToken() {
      getQiniuToken().then((res) => {
        this.qiniuToken = res.data;
      }).catch(() => { });
    },
    handleChange(file, type) {
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: this.qiniuToken,
      };
      this.$utils.uploadImgToQiniu(file.raw, qiniuData).then((res) => {
        this.form[type] = res
        if (type === "businessLicensePic") {
          this.getBusinessLicense(res)
        }
        if (type === "juridicalPersonCardPic1") {
          this.getIDCardFrontInfo(res)
        }
        if (type === "juridicalPersonCardPic2") {
          this.getIDCardBgInfo(res)
        }
      }).catch((err) => {
        this.$message.error(err);
      });
    },
    handlePreview(value) {
      this.previewUrl = value
      this.previewVisible = true
    },
    handleNext() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.companyName) {
            if (/\s/.test(this.form.companyName)) {
              return this.$message.error('公司名称不能含有空格')
            }
          }
          if (this.form.creditCode) {
            if (/\s/.test(this.form.creditCode)) {
              return this.$message.error('统一社会信用代码不能含有空格')
            }
          }
          this.form.businessLicenseAddress = this.form.businessLicenseAddress1.join("-") + "-" + this.form.businessLicenseAddress2
          this.form.step = 1
          // this.form.juridicalPersonCardPic = this.form.juridicalPersonCardPic1 + "," + this.form.juridicalPersonCardPic2
          let data = {
            path: "Business_SupplierSettled/AddSupplierSettled",
            parms: "",
            parmsJson: this.form
          }
          this.loading = true
          KSAXApiRequest(data).then(res => {
            this.loading = false
            if (res.data.success) {
              this.$router.push(`/SupEnter/Step2?phone=${this.$route.query.phone}`)
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      });
    },
    getBusinessLicense(url) {
      let data = {
        path: "erp/GetBusinessLicense",
        parms: ``,
        parmsJson: { url }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.form.creditCode = res.data.response
          this.getAlicloudCompany(res.data.response)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getAlicloudCompany(com) {
      let data = {
        path: "erp/GetAlicloudCompany",
        parms: ``,
        parmsJson: { com }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {

          const {
            address,
            area,
            businessStatus,
            bussiness,
            bussinessDes,
            cancelDate,
            city,
            companyCode,
            companyName,
            coutry,
            creditCode,
            faRen,
            isAuditState,
            phone,
            province,
            regDate,
          } = res.data.response
          this.form.companyName = companyName
          this.form.businessLicenseAddress2 = address
          this.form.establishDate = regDate
          this.form.businessTermStart = regDate
          this.form.businessTermEnd = (bussiness && bussiness != '长期') ? bussiness : '2999-12-31 00:00:00'
          this.form.businessRange = bussinessDes
          this.form.juridicalPersonName = faRen
          this.getAddressRecognition(`${province}${city}${area}${address}`)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getAddressRecognition(Text) {
      let data = {
        path: "System_Area/AddressRecognition",
        parms: ``,
        parmsJson: { Text }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          const {
            cityId,
            cityName,
            detailedAddress,
            districtId,
            districtName,
            name,
            provinceId,
            provinceName,
            streetId,
            streetName,
            telephone,
          } = res.data
          this.form.businessLicenseAddress1 = `${provinceName}-${cityName}-${districtName}`
          this.form.cityName = cityName
          this.form.cityId = cityId
          this.form.provinceName = provinceName
          this.form.provinceId = provinceId
          this.form.districtName = districtName
          this.form.districtId = districtId
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getIDCardFrontInfo(url) {
      let data = {
        path: "erp/GetIDCardFrontInfo",
        parms: ``,
        parmsJson: { url }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.form.juridicalPersonName = res.data.response.name
          this.form.juridicalPersonCardNo = res.data.response.number
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getIDCardBgInfo(url) {
      let data = {
        path: "erp/GetIDCardBgInfo",
        parms: ``,
        parmsJson: { url }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          const { timelimit } = res.data.response
          this.form.juridicalPersonStartDate = this.formatDate(timelimit.split('-')[0])
          this.form.juridicalPersonEndDate = this.formatDate(timelimit.split('-')[1])
          this.form.juridicalPersonLongDate = timelimit.split('-')[1] ? false : true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    formatDate(dateStr) {
      if (dateStr) {
        return dateStr.slice(0, 4) + '-' + dateStr.slice(4, 6) + '-' + dateStr.slice(6, 8);
      } else {
        return null
      }
    },
  },
};
</script>

<style scoped>
.ul li {
  padding: 0 30px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.li-active {
  background: #3B6FFA;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: bold;
  font-size: 14px;
  color: #FFFFFF;
}

.li-active-r {
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  border-left: 10px solid #3B6FFA;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
}

.li {
  background: #EBF2FA;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.li-r {
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  border-left: 10px solid #EBF2FA;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
}

.li-l {
  margin-left: -5px;
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  border-left: 10px solid transparent;
  border-top: 18px solid #EBF2FA;
  border-bottom: 18px solid #EBF2FA;
}

.title {
  background: #ecf5ff;
  display: flex;
  align-items: center;
}

.title p:first-child {
  height: 40px;
  width: 4px;
  background-color: #3B6FFA;
}

.title p:last-child {
  margin-left: 10px;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}

.supType-active {
  border-radius: 10px;
  border: 1px solid #409eff;
  padding: 10px 20px;
}

.supType {
  border-radius: 10px;
  border: 1px solid #e4e7ed;
  padding: 10px 20px;
}

.msg {
  line-height: 2;
  color: rgb(0 0 0 / 50%);
}

.uploader>>>.el-upload {
  width: 120px;
  height: 120px;
  border: 1px dashed #8c939d;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uploader img {
  max-width: 100%;
  max-height: 100%;
}
</style>
